__turbopack_context__.v({
  "holder_content_tab": "latest-news-module__VoXALa__holder_content_tab",
  "latest_news": "latest-news-module__VoXALa__latest_news",
  "latest_news_tabs": "latest-news-module__VoXALa__latest_news_tabs",
  "noticia_item": "latest-news-module__VoXALa__noticia_item",
  "noticia_item_description": "latest-news-module__VoXALa__noticia_item_description",
  "noticia_item_image": "latest-news-module__VoXALa__noticia_item_image",
  "noticia_item_text": "latest-news-module__VoXALa__noticia_item_text",
  "noticia_list": "latest-news-module__VoXALa__noticia_list",
  "tag_item": "latest-news-module__VoXALa__tag_item",
  "tag_list": "latest-news-module__VoXALa__tag_list",
});
